import PropTypes from "prop-types";

const FeaturedMapPin = ({ width = 40, height = 54 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 55 69"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_f_7050_7791)">
      <ellipse
        cx="27.0578"
        cy="63.7789"
        rx="9.01923"
        ry="3.22115"
        fill="black"
        fillOpacity="0.2"
      />
      <path
        d="M35.577 63.7789C35.577 64.0194 35.442 64.3161 35.0457 64.6507C34.6517 64.9833 34.052 65.3054 33.2672 65.5857C31.7019 66.1448 29.5066 66.5 27.0578 66.5C24.609 66.5 22.4137 66.1448 20.8484 65.5857C20.0636 65.3054 19.4639 64.9833 19.0699 64.6507C18.6737 64.3161 18.5386 64.0194 18.5386 63.7789C18.5386 63.5384 18.6737 63.2417 19.0699 62.9071C19.4639 62.5745 20.0636 62.2524 20.8484 61.9721C22.4137 61.413 24.609 61.0577 27.0578 61.0577C29.5066 61.0577 31.7019 61.413 33.2672 61.9721C34.052 62.2524 34.6517 62.5745 35.0457 62.9071C35.442 63.2417 35.577 63.5384 35.577 63.7789Z"
        stroke="black"
      />
    </g>
    <path
      d="M36.5703 51.3248L36.2999 51.4309L36.1284 51.6653L27.7917 63.0604L27.7906 63.062C27.7124 63.1693 27.606 63.2603 27.478 63.3245C27.3499 63.3887 27.2056 63.4231 27.0577 63.4231C26.9098 63.4231 26.7655 63.3887 26.6373 63.3245C26.5094 63.2603 26.403 63.1693 26.3248 63.062L26.3236 63.0604L17.987 51.6653L17.8155 51.4309L17.5451 51.3248C7.85687 47.524 1 38.0904 1 27.0577C1 12.6664 12.6664 1 27.0577 1C41.449 1 53.1154 12.6664 53.1154 27.0577C53.1154 38.0904 46.2585 47.524 36.5703 51.3248Z"
      fill="black"
      stroke="#FFCD06"
      strokeWidth="2"
    />
    <path
      d="M27.0577 32.8558L20.2415 37.0188L22.0946 29.2494L16.0298 24.0543L23.9905 23.4165L27.0577 16.0414L30.1249 23.4165L38.0868 24.0543L32.0209 29.2494L33.8739 37.0188L27.0577 32.8558Z"
      fill="#FFCC00"
    />
    <defs>
      <filter
        id="filter0_f_7050_7791"
        x="16.0386"
        y="58.5577"
        width="22.0386"
        height="10.4423"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="1"
          result="effect1_foregroundBlur_7050_7791"
        />
      </filter>
    </defs>
  </svg>
);

const { number } = PropTypes;

FeaturedMapPin.propTypes = {
  width: number,
  height: number
};

export default FeaturedMapPin;
